document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('click', function (e) {
        const btn = e.target.closest('.wc-notice-close');
        if (!btn) return;
        const inner = btn.closest('.kp-auth-overlay__inner');
        const box = btn.closest('.woocommerce-error, .woocommerce-message, .woocommerce-info');
        const wrap = btn.closest('.woocommerce-notices-wrapper');
        if (inner) {
            inner.remove();
        } else if (box) {
            box.remove();
        }
        if (wrap && !wrap.querySelector('li')) {
            wrap.remove();
        }
    });
});
